export const generateZillowLink = ({ address, city, state, zip }) => {
  return `https://www.zillow.com/homes/${address.replaceAll(' ', '-')}-${city.replaceAll(
    ' ',
    '-'
  )},-${state}-${zip}_rb`;
};
